/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

export type GetSensitiveWordAnalyzeQueryRequest = { keyword: string };

export const GetSensitiveWordAnalyzeQueryRequest$zodSchema: z.ZodType<
  GetSensitiveWordAnalyzeQueryRequest
> = z.object({
  keyword: z.string().describe("要分析的关键词，最长50字符。"),
});

/**
 * 未授权访问
 */
export type GetSensitiveWordAnalyzeQueryUnauthorizedResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetSensitiveWordAnalyzeQueryUnauthorizedResponseBody$zodSchema:
  z.ZodType<GetSensitiveWordAnalyzeQueryUnauthorizedResponseBody> = z.object({
    code: z.string().optional(),
    message: z.string().optional(),
  }).describe("未授权访问");

/**
 * 请求参数错误
 */
export type GetSensitiveWordAnalyzeQueryBadRequestResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetSensitiveWordAnalyzeQueryBadRequestResponseBody$zodSchema:
  z.ZodType<GetSensitiveWordAnalyzeQueryBadRequestResponseBody> = z.object({
    code: z.string().optional(),
    message: z.string().optional(),
  }).describe("请求参数错误");

export const GetSensitiveWordAnalyzeQueryLabel = {
  Sensitive: "sensitive",
  Normal: "normal",
} as const;
export type GetSensitiveWordAnalyzeQueryLabel = ClosedEnum<
  typeof GetSensitiveWordAnalyzeQueryLabel
>;

export const GetSensitiveWordAnalyzeQueryLabel$zodSchema = z.enum([
  "sensitive",
  "normal",
]);

export const GetSensitiveWordAnalyzeQueryCategory = {
  Safe: "safe",
  Threat: "threat",
  Porn: "porn",
  Fraud: "fraud",
  Insult: "insult",
} as const;
export type GetSensitiveWordAnalyzeQueryCategory = ClosedEnum<
  typeof GetSensitiveWordAnalyzeQueryCategory
>;

export const GetSensitiveWordAnalyzeQueryCategory$zodSchema = z.enum([
  "safe",
  "threat",
  "porn",
  "fraud",
  "insult",
]);

export type GetSensitiveWordAnalyzeQueryResult = {
  k?: string | undefined;
  label?: GetSensitiveWordAnalyzeQueryLabel | undefined;
  category?: GetSensitiveWordAnalyzeQueryCategory | undefined;
  confidence?: number | undefined;
};

export const GetSensitiveWordAnalyzeQueryResult$zodSchema: z.ZodType<
  GetSensitiveWordAnalyzeQueryResult
> = z.object({
  category: GetSensitiveWordAnalyzeQueryCategory$zodSchema.optional(),
  confidence: z.number().optional(),
  k: z.string().optional(),
  label: GetSensitiveWordAnalyzeQueryLabel$zodSchema.optional(),
});

/**
 * 分析成功
 */
export type GetSensitiveWordAnalyzeQueryResponseBody = {
  results?: Array<GetSensitiveWordAnalyzeQueryResult> | undefined;
  total?: number | undefined;
};

export const GetSensitiveWordAnalyzeQueryResponseBody$zodSchema: z.ZodType<
  GetSensitiveWordAnalyzeQueryResponseBody
> = z.object({
  results: z.array(z.lazy(() => GetSensitiveWordAnalyzeQueryResult$zodSchema))
    .optional(),
  total: z.int().optional(),
}).describe("分析成功");

export type GetSensitiveWordAnalyzeQueryResponse =
  | GetSensitiveWordAnalyzeQueryResponseBody
  | GetSensitiveWordAnalyzeQueryBadRequestResponseBody
  | GetSensitiveWordAnalyzeQueryUnauthorizedResponseBody;

export const GetSensitiveWordAnalyzeQueryResponse$zodSchema: z.ZodType<
  GetSensitiveWordAnalyzeQueryResponse
> = z.union([
  z.lazy(() => GetSensitiveWordAnalyzeQueryResponseBody$zodSchema),
  z.lazy(() => GetSensitiveWordAnalyzeQueryBadRequestResponseBody$zodSchema),
  z.lazy(() => GetSensitiveWordAnalyzeQueryUnauthorizedResponseBody$zodSchema),
]);
